import React, { useEffect, useState } from "react";

import HttpManager from "../../../../services/HttpManager";
import { Equipo, Llamada } from "../../../../services/v2/telefonia.service";
import { Aviso, cuando, DIR_TXT, DISP_CLASE, DISP_TXT, errorTexto, hace, minutos, num, pct, seg, telBonito } from "./comunes";
import { Compartido } from "./telefoniaController";

const iso = (d: Date) => d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0") + "-" + String(d.getDate()).padStart(2, "0");
const lunes = () => { const d = new Date(); d.setDate(d.getDate() - ((d.getDay() + 6) % 7)); return d; };

/**
 * Mi Equipo (Esteban, 2026-10-12): el reporte de llamadas de la supervisora. Por asesora de su equipo: minutos hablados,
 * intentos, contestadas y duración promedio; abajo, cada llamada con su grabación y siempre con el nombre de la asesora.
 * Supervisoras ven solo su equipo; dirección elige el equipo.
 */
const MiEquipo: React.FC<{ sh: Compartido }> = ({ sh }) => {
	const http = HttpManager.getInstance();
	const [periodo, setPeriodo] = useState<"hoy" | "semana" | "rango">("hoy");
	const [f, setF] = useState<any>({ desde: iso(new Date()), hasta: iso(new Date()), hora_desde: "", hora_hasta: "", equipo: "" });
	const [d, setD] = useState<Equipo | null>(null);
	const [sel, setSel] = useState<string>("");
	const [lista, setLista] = useState<{ llamadas: Llamada[]; total: number; porPagina: number } | null>(null);
	const [page, setPage] = useState<number>(1);
	const [audio, setAudio] = useState<{ id: number; url: string } | null>(null);
	const [error, setError] = useState<string | null>(null);

	const filtros = () => ({ desde: f.desde, hasta: f.hasta, hora_desde: periodo === "rango" ? f.hora_desde : "", hora_hasta: periodo === "rango" ? f.hora_hasta : "", equipo: f.equipo });
	useEffect(() => {
		setError(null);
		http.telefoniaService.equipo(sh.campusId, filtros()).then((r) => setD(r.data)).catch((e) => setError(errorTexto(e)));
	}, [sh.campusId, periodo, f.desde, f.hasta, f.hora_desde, f.hora_hasta, f.equipo]);
	useEffect(() => { setPage(1); }, [sel, d]);
	useEffect(() => {
		if (!d) return;
		const exts = sel ? sel : d.extensiones.join(",");
		if (!exts) { setLista({ llamadas: [], total: 0, porPagina: 50 }); return; }
		http.telefoniaService.llamadas(sh.campusId, { ...filtros(), equipo: "", extensiones: exts }, page).then((r) => setLista(r.data)).catch((e) => setError(errorTexto(e)));
	}, [d, sel, page]);

	const elegir = (p: "hoy" | "semana" | "rango") => {
		setPeriodo(p);
		if (p === "hoy") setF({ ...f, desde: iso(new Date()), hasta: iso(new Date()) });
		if (p === "semana") setF({ ...f, desde: iso(lunes()), hasta: iso(new Date()) });
	};
	const oir = async (l: Llamada) => {
		if (audio?.id === l.id) return setAudio(null);
		try {
			const r = await http.telefoniaService.grabacion(sh.campusId, l.id);
			if (!r.data.url) return setError("La grabación todavía no llega de la central (tarda un par de minutos).");
			setAudio({ id: l.id, url: r.data.url });
		} catch (e) { setError(errorTexto(e)); }
	};

	const k = d?.kpi;
	const nombreSel = sel ? d?.asesoras.find((a) => a.extension === sel)?.name : null;
	const paginas = lista ? Math.max(1, Math.ceil(lista.total / lista.porPagina)) : 1;
	return (
		<>
			<Aviso texto={error} onClose={() => setError(null)} />
			<div className="tf-filtros">
				<div className="tf-periodos">
					<button className={periodo === "hoy" ? "on" : ""} onClick={() => elegir("hoy")}>Hoy</button>
					<button className={periodo === "semana" ? "on" : ""} onClick={() => elegir("semana")}>Esta Semana</button>
					<button className={periodo === "rango" ? "on" : ""} onClick={() => elegir("rango")}>Otro Rango</button>
				</div>
				{periodo === "rango" ? (
					<>
						<div className="tf-campo"><label>Desde</label><input type="date" value={f.desde} onChange={(e) => setF({ ...f, desde: e.target.value })} /></div>
						<div className="tf-campo"><label>Hora</label><input type="time" value={f.hora_desde} onChange={(e) => setF({ ...f, hora_desde: e.target.value })} /></div>
						<div className="tf-campo"><label>Hasta</label><input type="date" value={f.hasta} onChange={(e) => setF({ ...f, hasta: e.target.value })} /></div>
						<div className="tf-campo"><label>Hora</label><input type="time" value={f.hora_hasta} onChange={(e) => setF({ ...f, hora_hasta: e.target.value })} /></div>
					</>
				) : null}
				{d && !d.soloMiEquipo && d.equipos.length > 1 ? (
					<div className="tf-campo"><label>Equipo</label>
						<select value={f.equipo} onChange={(e) => { setSel(""); setF({ ...f, equipo: e.target.value }); }}>
							<option value="">Todos</option>{d.equipos.map((t) => <option key={t} value={t}>{t}</option>)}
						</select>
					</div>
				) : null}
			</div>
			{!d ? <div className="nu-vacio">Cargando…</div> : !d.asesoras.length ? (
				<div className="nu-vacio">{d.soloMiEquipo ? "Todavía no hay asesoras con extensión en tu equipo. Pide que te liguen a tu equipo en el organigrama o en Extensiones." : "Nadie con extensión en este equipo."}</div>
			) : (
				<>
					<div className="tf-kpis">
						<div className="nu-kpi"><span>Minutos Hablados</span><b>{minutos(k!.hablado)}</b><small>{k!.activas} de {k!.asesoras} asesoras llamaron</small></div>
						<div className="nu-kpi"><span>Intentos</span><b>{num(k!.intentos)}</b><small>llamadas salientes</small></div>
						<div className="nu-kpi"><span>Contestadas</span><b>{num(k!.contestadas)}</b><small>{pct(k!.sal_ok, k!.intentos)} de los intentos · {num(k!.entrantes)} entrantes</small></div>
						<div className="nu-kpi"><span>Duración Promedio</span><b>{k!.promedio !== null ? seg(k!.promedio) : "–"}</b><small>por llamada contestada</small></div>
					</div>
					<div className="nu-bloque">
						<div className="nu-bloque-tit">Por Asesora <small>toca una para ver sus llamadas</small></div>
						<div className="tf-scroll-x">
							<table className="nu-tabla tf-equipo">
								<thead><tr><th>Asesora</th><th>Minutos</th><th>Intentos</th><th>Contestadas</th><th>Entrantes</th><th>Promedio</th><th>Última</th></tr></thead>
								<tbody>
									{d.asesoras.map((a) => (
										<tr key={a.extension} className={"tf-fila-click" + (sel === a.extension ? " on" : "") + (!a.total ? " tf-sin" : "")} onClick={() => setSel(sel === a.extension ? "" : a.extension)}>
											<td><b>{a.name}</b> <span className="nu-tenue">· {a.extension}{d.soloMiEquipo || !a.team ? "" : " · " + a.team}</span></td>
											<td>{minutos(a.hablado)}</td>
											<td>{num(a.intentos)}</td>
											<td>{num(a.contestadas)} <span className="nu-tenue">{a.intentos ? "(" + pct(a.sal_ok, a.intentos) + ")" : ""}</span></td>
											<td>{num(a.entrantes)}</td>
											<td>{a.promedio !== null ? seg(a.promedio) : "–"}</td>
											<td>{a.ultima ? hace(a.ultima) : <span className="nu-tenue">Sin llamadas</span>}</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
					</div>
					<div className="nu-bloque" style={{ marginTop: 14 }}>
						<div className="nu-bloque-tit">{nombreSel ? "Llamadas de " + nombreSel : "Todas las Llamadas del Equipo"} <small>{lista ? num(lista.total) : "…"}</small>
							{sel ? <button className="nu-btn chico" style={{ marginLeft: 8 }} onClick={() => setSel("")}>Ver Todas</button> : null}</div>
						<div className="tf-scroll-x">
							<table className="nu-tabla tf-equipo">
								<thead><tr><th>Asesora</th><th className="izq">Cuándo</th><th className="izq">Tipo</th><th className="izq">Cliente</th><th className="izq">Cómo Terminó</th><th>Duración</th><th>Grabación</th></tr></thead>
								<tbody>
									{(lista?.llamadas || []).map((l) => (
										<React.Fragment key={l.id}>
											<tr>
												<td><b>{l.asesora || l.extension || "–"}</b></td>
												<td className="izq">{cuando(l.started_at)}</td>
												<td className="izq"><span className={"tf-chip " + (l.direction === "in" ? "in" : "")}>{DIR_TXT[l.direction]}</span></td>
												<td className="izq">{l.cliente || l.wa_nombre || telBonito(l.remote_number)}{l.cliente || l.wa_nombre ? <span className="nu-tenue"> · {telBonito(l.remote_number)}</span> : null}</td>
												<td className="izq"><span className={"tf-chip " + (DISP_CLASE[l.disposition] || "")}>{DISP_TXT[l.disposition] || l.disposition}</span></td>
												<td>{l.talk_seconds ? seg(l.talk_seconds) : "–"}</td>
												<td>{l.bool_recorded ? <button className="nu-btn chico" onClick={() => oir(l)}>{audio?.id === l.id ? "Cerrar" : "▶ Oír"}</button> : <span className="nu-tenue">–</span>}</td>
											</tr>
											{audio?.id === l.id ? (
												<tr><td colSpan={7} className="izq"><div className="tf-audio"><span className="nu-tenue">{l.asesora || l.extension} · {telBonito(l.remote_number)}</span><audio controlsList="nodownload" controls autoPlay src={audio.url} /></div></td></tr>
											) : null}
										</React.Fragment>
									))}
									{lista && !lista.llamadas.length ? <tr><td colSpan={7} className="nu-vacio">Sin llamadas en este periodo.</td></tr> : null}
								</tbody>
							</table>
						</div>
						{paginas > 1 ? (
							<div className="tf-paginas">
								<button className="nu-btn chico" disabled={page <= 1} onClick={() => setPage(page - 1)}>Anterior</button>
								<span className="nu-tenue">Página {page} de {paginas}</span>
								<button className="nu-btn chico" disabled={page >= paginas} onClick={() => setPage(page + 1)}>Siguiente</button>
							</div>
						) : null}
					</div>
				</>
			)}
		</>
	);
};

export default MiEquipo;
